export default "__VITE_ASSET__Bynd8gAW__"